module.exports = __webpack_public_path__ + "static/img/边7.4491fc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边7.png
// module id = sB6m
// module chunks = 2